import { atom } from 'recoil';

// Creating an atom to hold a counter value
export const assessmentAtom = atom({
    key: 'assessmentId',// Unique ID for the atom
    default: '',           // Initial value
});

export const loveInterestAtom = atom({
    key: "loveInterest",
    default: { loveInterest: 'Tom' }
})

export const randomGuestAtom = atom({
    key: "randomGuest",
    default: null
})

// Session timing atom for PSSI/ASI calculations
export const sessionTimingAtom = atom({
    key: "sessionTiming",
    default: {
        sessionStartTime: null,  // Timestamp when assessment begins
        moduleStartTimes: {},    // Map of moduleId -> start timestamp
        trialData: []            // Array of trial-level data for PSSI/ASI
    }
})
